module.exports = __webpack_public_path__ + "trails.0fc3b15f1f66aed59d8e75646c39687a.png";